import React, { forwardRef } from "react";

import { sql } from "@codemirror/lang-sql";
import CodeMirror from "@uiw/react-codemirror";
import { format } from "sql-formatter";

const SQLHistoryCard = forwardRef(({ item, setSqlQuery, theme }, ref) => (
  <div
    ref={ref}
    className="p-4 shadow-sm bg-white dark:bg-cs-ui-gray-800 mx-4 hover:shadow-lg hover:bg-gray-50 transition-all cursor-pointer"
    onClick={() =>
      setSqlQuery(
        format(item.sql_query, {
          uppercase: true,
        })
      )
    }
  >
    <CodeMirror
      value={format(item.sql_query, {
        uppercase: true,
      })}
      width="100%"
      editable={false}
      extensions={[sql()]}
      theme={theme}
    />
  </div>
));

SQLHistoryCard.displayName = "SQLHistoryCard";

export default SQLHistoryCard;
